import { Component, OnInit, EventEmitter, AfterViewInit } from "@angular/core";
// import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions } from 'ngx-uploader';
import { environment } from "../environments/environment";
import { ProjectService } from "./services/project.service";
import { CommentService } from "./services/comment.service";
import { Comment } from "./models/comment";
import { states } from "./models/states";
import { FileUploader } from "ng2-file-upload";
import { Ng2DeviceService } from "ng2-device-detector";
import {
  Router,
  ActivatedRoute,
  Params,
  RoutesRecognized,
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "ESA Comment Tracker";
  project = null;
  environment = environment;
  showErrorPage = false;
  pageLoading = true;
  projectId = environment.projectID;
  photo = "assets/default-background.jpg";
  theme = "default";
  page = 1;
  languages = [
    { lang: "en", label: "English" },
    { lang: "ceb", label: "Cebuano" },
    { lang: "zh", label: "Chinese (Simplified)" },
    { lang: "zh-Hant", label: "Chinese (Traditional)" },
    { lang: "fil", label: "Filipino" },
    { lang: "fr", label: "French" },
    { lang: "hmn", label: "Hmong" },
    { lang: "ja", label: "Japanese" },
    { lang: "kh", label: "Khmer" },
    { lang: "ko", label: "Korean" },
    { lang: "mo", label: "Mongolian" },
    { lang: "ru", label: "Russian" },
    { lang: "sp", label: "Spanish" },
    { lang: "va", label: "Vietnamese" },
    { lang: "so", label: "Somali" },
    { lang: "am", label: "Amharic" },
  ].filter(function (l) {
    return environment.langs.indexOf(l.lang) >= 0;
  });

  constructor(
    private projectService: ProjectService,
    private commentService: CommentService,
    private deviceService: Ng2DeviceService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    //this.files = []; // local uploading files array
    // this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    // this.humanizeBytes = humanizeBytes;
    this.translate.setDefaultLang("en");
    this.translate.use("en");
    translate.addLangs(environment.langs);
    translate.setDefaultLang("en");

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");
  }

  // load project
  loadProject(): void {
    this.router.events.subscribe((val) => {
      if (val instanceof RoutesRecognized) {
        // get the integer parameter from the route '/#'
        this.projectId = val.state.root.firstChild
          ? +val.state.root.firstChild.params.id
          : environment.projectID; // (+) converts string 'id' to a number
        // set the environment project id
        environment.projectID = this.projectId;
        // initialize the model
        // this.model = new Comment(environment.databaseID, environment.projectID);
        // set theme
        this.theme = "nisqually";
        // get the project information from the API
        this.projectService.fetchProject().subscribe(
          (success) => {
            this.project = success;
            this.projectService.updateCurrentProject(this.project);

            if (this.project.id) {
              // prepare photo url for background
              this.photo = "url(" + this.project.background + ")";
              if (Array.isArray(this.project.topics)) {
                this.project.topics.sort((left, right): number => {
                  if (left.id < right.id) return -1;
                  if (left.id > right.id) return 1;
                  return 0;
                });
              }
            } else {
              this.project = null;
              this.showErrorPage = true;
            }
            this.pageLoading = false;
          },
          (error) => {
            console.log("Error: ", error);
            this.showErrorPage = true;
            this.pageLoading = false;
          }
        );
      }
    });
  }

  // application start
  ngOnInit(): void {
    this.loadProject();
  }

  ngAfterViewInit() {
    // var google = (function () {
    //   var gtConstEvalStartTime = new Date(); function d(b) { var a = document.getElementsByTagName("head")[0]; a || (a = document.body.parentNode.appendChild(document.createElement("head"))); a.appendChild(b) } function _loadJs(b) { var a = document.createElement("script"); a.type = "text/javascript"; a.charset = "UTF-8"; a.src = b; d(a) } function _loadCss(b) { var a = document.createElement("link"); a.type = "text/css"; a.rel = "stylesheet"; a.charset = "UTF-8"; a.href = b; d(a) } function _isNS(b) { b = b.split("."); for (var a = window, c = 0; c < b.length; ++c)if (!(a = a[b[c]])) return !1; return !0 }
    //   function _setupNS(b) { b = b.split("."); for (var a = window, c = 0; c < b.length; ++c)a.hasOwnProperty ? a.hasOwnProperty(b[c]) ? a = a[b[c]] : a = a[b[c]] = {} : a = a[b[c]] || (a[b[c]] = {}); return a } window.addEventListener && "undefined" == typeof document.readyState && window.addEventListener("DOMContentLoaded", function () { document.readyState = "complete" }, !1);
    //   if (_isNS('google.translate.Element')) { return } (function () { var c = _setupNS('google.translate._const'); c._cest = gtConstEvalStartTime; gtConstEvalStartTime = undefined; c._cl = 'en'; c._cuc = 'googleTranslateElementInit'; c._cac = ''; c._cam = ''; c._ctkk = '428728.3271352322'; var h = 'translate.googleapis.com'; var s = (true ? 'https' : window.location.protocol == 'https:' ? 'https' : 'http') + '://'; var b = s + h; c._pah = h; c._pas = s; c._pbi = b + '/translate_static/img/te_bk.gif'; c._pci = b + '/translate_static/img/te_ctrl3.gif'; c._pli = b + '/translate_static/img/loading.gif'; c._plla = h + '/translate_a/l'; c._pmi = b + '/translate_static/img/mini_google.png'; c._ps = b + '/translate_static/css/translateelement.css'; c._puh = 'translate.google.com'; _loadCss(c._ps); _loadJs(b + '/translate_static/js/element/main.js'); })();
    // })();
    // function googleTranslateElementInit() {
    //   new google.translate.TranslateElement({ pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE }, 'google_translate_element');
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts